module.exports = __webpack_public_path__ + "img/DateTime.0f9f755d.svg";